<template>
  <div id="admin_institutions">
    <v-data-table
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :headers="headers"
      :search="search_form"
      :items="items"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, 100]
      }"
      :items-per-page="20"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field
          v-model="search_form"
          class="pa-3"
          label="Vyhľadať"
        />
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editSpracovatelia(item)"
        >
          mdi-account-group
        </v-icon>
      </template>
    </v-data-table>
    <v-btn
      fab
      bottom
      left
      color="pink"
      dark
      fixed
      @click="create"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-card-title v-if="update">
          Zmena inštitúcie
        </v-card-title>
        <v-card-title v-else>
          Nová inštitúcia
        </v-card-title>

        <v-container grid-list-sm>
          <v-layout wrap>
            <v-flex xs12>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.name"
                    label="Názov"
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="new_item.type"
                    placeholder="Typ"
                    label="Typ"
                    :items="selects.types"
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.address"
                    label="Adresa"
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="dialog = false; update = false"
          >
            Zrušiť
          </v-btn>

          <v-btn
            v-if="update"
            text
            @click="updateItem"
          >
            Zmeniť
          </v-btn>
          <v-btn
            v-else
            text
            @click="createItem"
          >
            Vytvoriť
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar_success"
      color="success"
      :timeout="3000"
    >
      Vytvorené
      <v-btn
        text
        @click="snackbar_success = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

export default {
  data: () => ({
    dialog: false,
    loading: true,
    update: false,

    snackbar_success: false,
    snackbar_error: false,
    search_form: "",
    totalItems: 0,
    options: {},

    headers: [
      { text: "Interné ID", value: "id" },
      { text: "Názov", value: "name" },
      { text: "Typ", value: "type" },
      { text: 'Akcie', value: 'actions', sortable: false },
    ],
    selects: {
      types: ["Ústav", "GR ZVJS", "ŠNN"],
      institutions: {}
    },
    new_item: {
      name: "",
      type: "",
      address: ""
    },
    items: []
  }),

  watch: {
    search_form() {
      this.getDataFromApi();
    },
    options: {
      handler() {
        this.getDataFromApi();
      }
    },
    deep: true
  },

  created() { },

  methods: {
    editSpracovatelia(item) {
      this.$router.push({
        name: "admin_institutions_spracovatelia",
        params: { id: item.id }
      })
    },
    historyItem(item) {
      this.$router.push({
        name: "institutions_history",
        params: { id: item.id }
      });
    },
    editItem(item) {
      this.new_item = Object.assign({}, item);
      this.dialog = true;
      this.update = true;
    },
    create() {
      this.dialog = true;
      this.update = false;

      this.new_item.name = "";
      this.new_item.type = "";
      this.new_item.address = "";
    },
    getInstitutions(sort, search, limit, offset) {
      this.loading = true;
      apiService.getInstitutionsAdmin(sort, search, limit, offset).then(response => {
        this.items = response.results;
        this.totalItems = response.count;
        this.loading = false;
      });
    },
    createItem() {
      apiService.createInstitutionAdmin(this.new_item).then(
        () => {
          this.snackbar_success = true;
          this.getDataFromApi();
          this.dialog = false;

          this.new_item.name = "";
          this.new_item.type = "";
          this.new_item.address = "";
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    updateItem() {
      apiService.updateInstitutionAdmin(this.new_item).then(
        () => {
          this.snackbar_success = true;
          this.getDataFromApi();
          this.dialog = false;
          this.update = false;

          this.new_item.name = "";
          this.new_item.type = "";
          this.new_item.address = "";
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let sort = "";
      if (sortBy) {
        if (sortBy.length === 1 && sortDesc.length === 1) {
          sort = sortBy[0]
            .replace(/\./g, "__")
            .replace("prisoner_full", "prisoner")
            .replace("institution_full", "institution");
          if (!sortDesc[0]) sort = "-" + sort;
        }
      }

      let offset = "";
      if (itemsPerPage > 0) {
        offset = (page - 1) * itemsPerPage;
      }

      this.getInstitutions(sort, this.search_form, itemsPerPage, offset);
    }
  }
};
</script> 